import { Link } from 'react-router-dom';

/** 404-Seite */
export default function NotFoundPage() {
  return (
    <div
      className="flex min-h-screen flex-col items-center justify-center gap-4"
      data-testid="not-found"
    >
      <div className="text-6xl">🤔</div>
      <h1 className="text-3xl font-bold text-gray-800 dark:text-gray-100">Seite nicht gefunden</h1>
      <p className="text-gray-600 dark:text-gray-300">Hier gibt es kein Spiel zu entdecken.</p>
      <Link
        to="/"
        className="rounded-xl bg-indigo-500 px-6 py-3 font-semibold text-white transition hover:bg-indigo-600"
      >
        ← Zurück zur Auswahl
      </Link>
    </div>
  );
}
